// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import InfoOutline from '../_raw/ui/icon_info_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(InfoOutline);
